
const resizerStyleDict = {
    leftRightTop: `
        top: 0;
        width: 18px;
        height: 18px;
        cursor: nw-resize;
    `,
    leftRightBottom: `
        bottom: 0;
        width: 18px;
        height: 18px;
        cursor: nw-resize;
    `,
    leftRight: `
        top: 20px;
        bottom: 20px;
        width: 10px;
        cursor: ew-resize;
    `,
    topBottom: `
        left: 20px;
        right: 20px;
        height: 10px;
        cursor: ns-resize;
    `,
}
const resizerDict = {
    directions: ['left', 'right', 'top', 'bottom', 'left-top', 'right-top', 'left-bottom', 'right-bottom'],
    style: {
        'left': `
            ${resizerStyleDict.leftRight}
            left: -2px;
            right: auto !important;
        `,
        'left-top': `
            ${resizerStyleDict.leftRightTop}
            left: 0;
            right: auto !important;
        `,
        'left-bottom': `
            ${resizerStyleDict.leftRightBottom}
            cursor: ne-resize;
            left: 0;
            right: auto !important;
        `,
        'right': `
            ${resizerStyleDict.leftRight}
            right: -2px;
            left: auto !important;
        `,
        'right-top': `
            ${resizerStyleDict.leftRightTop}
            cursor: ne-resize;
            right: 0;
            left: auto !important;
        `,
        'right-bottom': `
            ${resizerStyleDict.leftRightBottom}
            right: 0;
            left: auto !important;
        `,
        'top': `
            ${resizerStyleDict.topBottom}
            top: -2px;
            bottom: auto !important;
        `,
        'bottom': `
            ${resizerStyleDict.topBottom}
            bottom: -2px;
            top: auto !important;
        `
    }
}

import { nextTick } from 'vue'
// 拖拽的指令
export default {
    mounted(el, binding) {
        // 自定义属性，判断是否可拖拽
        if (!binding.value) {
            console.error('Missing directive value')
            return
        }

        const { headerDom, contentDom, fullDom, showResize = true, showFull = false, showDrag = true, showFixedRight = false, resizeLocation = ['all'], initBoxStyle = {} } = binding.value;

        if (typeof headerDom !== 'string' || headerDom.trim() === '') {
            console.error('Invalid drag handle selector')
            return
        }

        // 使用 nextTick 确保元素已渲染
        nextTick(() => {
            const dialogHeaderEl = el.querySelector(headerDom)
            const dragDom = el.querySelector(contentDom)

            // 增加空值检查
            if (!dialogHeaderEl || !dragDom) {
                console.error('Drag elements not found', {
                    header: headerDom,
                    container: contentDom
                })
                return
            }

            dragDom.style.width = initBoxStyle.width;
            dragDom.style.height = initBoxStyle.height;
            dragDom.style.left = initBoxStyle.left;
            dragDom.style.top = initBoxStyle.top;
            dragDom.style.right = initBoxStyle.right;

            // 新增移动功能
            if (showDrag) {
                dialogHeaderEl.style.cssText += ';cursor:move;'

                // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
                const sty = (function () {
                    if (document.body.currentStyle) {
                        // 在ie下兼容写法
                        return (dom, attr) => dom.currentStyle[attr]
                    }
                    return (dom, attr) => getComputedStyle(dom, null)[attr]
                })()

                dialogHeaderEl.onmousedown = (e) => {
                    //判断元素移动还是被点击
                    let isMove = false;

                    // 鼠标按下，计算当前元素距离可视区的距离
                    const disX = e.clientX - dialogHeaderEl.offsetLeft
                    const disY = e.clientY - dialogHeaderEl.offsetTop
                    const screenWidth = document.body.clientWidth * 2
                    const screenHeight = document.documentElement.clientHeight * 2

                    // 修改：移除调试日志
                    const dragDomWidth = dragDom.offsetWidth
                    const dragDomHeight = dragDom.offsetHeight

                    // 修复：正确的边界计算
                    const minDragDomLeft = -dragDom.offsetLeft
                    const maxDragDomLeft = screenWidth - (dragDom.offsetLeft + dragDomWidth)

                    const minDragDomTop = -dragDom.offsetTop
                    const maxDragDomTop = screenHeight - (dragDom.offsetTop + dragDomHeight)

                    // 获取到的值带px 正则匹配替换
                    let styL = sty(dragDom, 'left')
                    // 为兼容ie
                    if (styL === 'auto') styL = '0px'
                    let styT = sty(dragDom, 'top')

                    // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
                    if (styL.includes('%')) {
                        styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
                        styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
                    } else {
                        styL = +styL.replace(/px/g, '')
                        styT = +styT.replace(/px/g, '')
                    }

                    document.onmousemove = function (e) {
                        // 通过事件委托，计算移动的距离
                        let left = e.clientX - disX
                        let top = e.clientY - disY

                        // 修复边界处理逻辑
                        left = Math.max(minDragDomLeft, Math.min(left, maxDragDomLeft))
                        top = Math.max(minDragDomTop, Math.min(top, maxDragDomTop))

                        // 移动当前元素
                        isMove = true
                        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
                    }

                    document.onmouseup = function (e) {
                        document.onmousemove = null
                        document.onmouseup = null
                        // 新增：拖拽结束后重置状态
                        isMove = false
                    }
                    return false
                }
            }

            // 判断是否显示调整大小功能
            if (!showResize) return;
            // 新增调整大小功能
            const createResizer = (direction) => {
                const resizer = document.createElement('div')
                resizer.className = `resizer ${direction}`
                // 新样式定义
                const styleMap = resizerDict.style;
                
                resizer.style.cssText = `
                    position: absolute;
                    z-index: 1;
                    background: transparent;
                    ${styleMap[direction]}
                `;

                resizer.addEventListener('mousedown', (e) => {
                    // 新增判断：当点击的是滚动条时跳过处理
                    const target = e.target
                    const isScrollbar = target.classList.contains('resizer') && getComputedStyle(target).cursor === 'auto';
                    if (!isScrollbar) {
                        handleResize(e, direction)
                    }
                })
                return resizer
            }

            // 添加四个方向的调整柄
            const directions = resizeLocation.includes('all') ? resizerDict.directions : resizerDict.directions.filter((el) => resizeLocation.includes(el));

            directions.forEach((dir) => {
                dir && dragDom.appendChild(createResizer(dir))
            })

            // 调整大小处理函数
            const handleResize = (e, direction) => {
                e.preventDefault()

                const startX = e.clientX
                const startY = e.clientY
                const startWidth = dragDom.offsetWidth
                const startHeight = dragDom.offsetHeight
                const startLeft = dragDom.offsetLeft
                const startTop = dragDom.offsetTop

                const MIN_WIDTH = 300;  // 最小宽度
                const MIN_HEIGHT = 400; // 最小高度
                const MAX_WIDTH = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;; // 最大宽度
                const MAX_HEIGHT = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;; // 最大高度

                document.onmousemove = (e) => {
                    const deltaX = e.clientX - startX
                    const deltaY = e.clientY - startY

                    // 新增尺寸限制逻辑
                    let newWidth = Math.min(
                        direction.includes('right') ? startWidth + deltaX : startWidth,
                        MAX_WIDTH
                    )
                    let newHeight = Math.min(
                        direction.includes('bottom') ? startHeight + deltaY : startHeight,
                        MAX_HEIGHT
                    )
                    let newLeft = startLeft
                    let newTop = startTop

                    if (direction.includes('right')) {
                        newWidth = Math.max(newWidth, MIN_WIDTH)
                    }
                    if (direction.includes('left')) {
                        newWidth = Math.max(startWidth - deltaX, MIN_WIDTH)
                        newWidth = Math.min(newWidth, MAX_WIDTH)  // 新增左边界限制
                        newLeft = startLeft + (startWidth - newWidth)
                    }
                    if (direction.includes('bottom')) {
                        newHeight = Math.max(newHeight, MIN_HEIGHT)
                    }
                    if (direction.includes('top')) {
                        newHeight = Math.max(startHeight - deltaY, MIN_HEIGHT)
                        newHeight = Math.min(newHeight, MAX_HEIGHT) // 新增上边界限制
                        newTop = startTop + (startHeight - newHeight)
                    }

                    if (showFixedRight) {
                        dragDom.style.right = '0';
                        dragDom.style.left = 'auto';
                    } else {
                        dragDom.style.left = `${newLeft}px`
                    }

                    // 应用新尺寸
                    dragDom.style.width = `${newWidth}px`
                    dragDom.style.height = `${newHeight}px`
                    dragDom.style.top = `${newTop}px`
                }

                document.onmouseup = () => {
                    document.onmousemove = null
                    document.onmouseup = null
                }
            }

            const fullDomData = el.querySelector(fullDom);
            if (fullDomData && showFull) {
                // 创建 ResizeObserver 实例
                const resizeObserver = new ResizeObserver(entries => {
                    for (const entry of entries) {
                        const { width, height } = entry.contentRect
                        dragDom.style.width = width + 'px';
                        dragDom.style.height = height + 'px';
                        dragDom.style.left = 'auto';
                        dragDom.style.right = '0';
                        dragDom.style.top = '0';
                    }
                })

                // 开始观察目标元素
                resizeObserver.observe(fullDomData)

                // 保存 observer 实例以便卸载时使用
                el._resizeObserver = resizeObserver
            }
        })
    },

    unmounted(el, binding) {
        // 组件卸载时断开观察
        if (el._resizeObserver) {
            el._resizeObserver.disconnect()
            delete el._resizeObserver
        }
    }
}